import vuex from '../store'
export function hasPermission(permission){
   let permissionList = this.$store.state.permission;
   return permissionList.indexOf(permission) > -1
}


// WEBPACK FOOTER //
// ./src/utils/hasPermission.js